import { hourMinutesFormatter } from "../utils/hourMinutesFormatter";
export const getDurationOptions = (durOpts) => {
    return durOpts.map((value) => {
        return {
            value: value,
            label: hourMinutesFormatter(value),
        };
    });
};
